import { filter, tap, switchMap } from 'rxjs/operators';
import { Component, Input } from '@angular/core';
import { Store, Action } from '@ngrx/store';
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
  AbstractControl
} from '@angular/forms';
import { Observable, merge, of, Subject } from 'rxjs';
//import { MatDialog } from '@angular/material/dialog';

import * as fromRoot from '../../reducers';
import * as forms from '../../actions/forms';
import * as utils from '../../shared/utils';
import * as notifications from '../../actions/notifications';

@Component({
  selector: 'edge-change-email',
  templateUrl: './change-email.component.html',
  styleUrls: ['./change-email.component.scss']
})
export class ChangeEmailComponent {
  @Input() sport: string = '';

  formName = 'changeEmail';
  submitted = false;
  public changeEmailForm: FormGroup = new FormGroup({
    title: new FormControl(''),
    description: new FormControl('')
  });

  validationMessages: any = {
    emailAddress: {
      required: 'Please provide your email address',
      email: 'Please provide a valid email address'
    },
    password: {
      required: 'Please provide your password'
    },
    newEmailAddress: {
      required: 'Please provide a new email address',
      email: 'Please provide a valid email address'
    },
    retypeEmailAddress: {
      required: 'Please provide your email address',
      nomatch: 'Email Confirmation must match new Email Address'
    }
  };

  action$ = new Subject();
  formAction$: Observable<Action> = this.action$.pipe(
    tap(() => (this.submitted = true)),
    switchMap((data) =>
      of(forms.FormRequestAction(utils.fromForm(this.formName, data))).pipe(
        filter(() => this.changeEmailForm.valid)
      )
    )
  );

  constructor(
    private store: Store<fromRoot.State>,
    private formBuilder: FormBuilder
    //public dialog: MatDialog
  ) {
    merge(this.formAction$).subscribe(store);
    store.dispatch(forms.FormCreateAction({ formName: this.formName }));
    this.buildChangeEmailForm();
  }

  buildChangeEmailForm(): void {
    this.changeEmailForm = this.formBuilder.group({
      emailAddress: [
        '',
        Validators.compose([Validators.required, Validators.email])
      ],
      password: ['', Validators.compose([Validators.required])],
      newEmailAddress: [
        '',
        Validators.compose([Validators.required, Validators.email])
      ],
      retypeEmailAddress: [
        '',
        Validators.compose([Validators.required, this.emailMatcher])
      ]
    });

    this.changeEmailForm.valueChanges.subscribe(() => this.onValueChanged());
    this.onValueChanged();
  }

  onValueChanged(): void {
    if (!this.changeEmailForm) {
      return;
    }
    const form = this.changeEmailForm;
    if (
      form.value.newEmailAddress === form.value.retypeEmailAddress &&
      form.value.retypeEmailAddress !== ''
    ) {
      form.controls.retypeEmailAddress.updateValueAndValidity({
        onlySelf: true
      });
    }
  }

  emailMatcher(control: AbstractControl): any {
    const password = control.root.get('newEmailAddress');
    const confirm = control.root.get('retypeEmailAddress');
    if (!password || !confirm) {
      return null;
    }
    return password.value === confirm.value ? null : { nomatch: true };
  }

  hasError(key: string, type: string): boolean {
    const control = this.changeEmailForm.controls[key];
    return control.errors ? control.errors[type] : false;
  }

  getErrorMessage(key: string, type: string): string {
    return this.validationMessages[key][type];
  }

  onSubmit(): void {
    this.submitted = true;
    if (!this.changeEmailForm.valid) {
      this.store.dispatch(
        notifications.AddFailureNotification(
          'Please fix the form errors and try again.'
        )
      );
    }
    this.action$.next(this.changeEmailForm.value);
  }
}
